<script>
/**
 * Le bandeau de filtres des écrans de liste.
 *
 * Une seule rangée de champs devenait illisible dès qu'on en ajoutait: on
 * garde donc en vue ce qui sert à chaque visite — la recherche et deux ou
 * trois critères rapides — et le reste s'ouvre dans un panneau, rangé par
 * champs nommés. Le compteur dit combien de critères travaillent, panneau
 * fermé comme ouvert, pour qu'un filtre replié ne se fasse jamais oublier.
 */
export default {
  name: 'FilterPanel',
  props: {
    /** Le texte de recherche, en v-model. */
    modelValue: { type: String, default: '' },
    searchPlaceholder: { type: String, default: 'Rechercher…' },
    /** Nombre de critères actifs, pastille du bouton « Filtres ». */
    activeCount: { type: Number, default: 0 },
    /** Ouvre le panneau d'emblée — au rappel d'un préréglage, par exemple. */
    expanded: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'update:expanded', 'reset'],
  data() {
    return {
      open: this.expanded,
    };
  },
  watch: {
    expanded(value) {
      this.open = value;
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
      this.$emit('update:expanded', this.open);
    },
  },
};
</script>

<template>
  <div class="filter-panel">
    <div class="filter-panel__bar">
      <div class="filter-panel__search">
        <i class="ri-search-line"></i>
        <input
          type="text"
          class="list-input"
          data-testid="filter-search"
          :placeholder="searchPlaceholder"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
        />
      </div>

      <div class="filter-panel__quick">
        <slot name="quick"></slot>
      </div>

      <div class="filter-panel__tools">
        <button
          type="button"
          class="list-btn list-btn--ghost filter-panel__toggle"
          :class="{ 'filter-panel__toggle--on': open || activeCount > 0 }"
          :aria-expanded="open ? 'true' : 'false'"
          data-testid="filter-toggle"
          @click="toggle"
        >
          <i class="ri-equalizer-line"></i>
          Filtres avancés
          <span v-if="activeCount" class="filter-panel__count">
            {{ activeCount }}
          </span>
          <i :class="open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
        </button>

        <slot name="saved"></slot>
      </div>
    </div>

    <div
      v-show="open"
      class="filter-panel__advanced"
      data-testid="filter-advanced"
    >
      <div class="filter-panel__grid">
        <slot name="advanced"></slot>
      </div>

      <div class="filter-panel__footer">
        <span class="filter-panel__hint">
          Les filtres s'appliquent au fur et à mesure.
        </span>
        <button
          type="button"
          class="filter-panel__reset"
          :disabled="activeCount === 0"
          data-testid="filter-reset"
          @click="$emit('reset')"
        >
          <i class="ri-refresh-line"></i>
          Réinitialiser
        </button>
      </div>
    </div>
  </div>
</template>
